import { Component, OnInit } from '@angular/core';
import { Certificate_Interface } from 'src/app/Interface/Certificate_Interface';
import { CertificateService } from 'src/app/Service/Certificate/Certificate.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-CertificateList',
  templateUrl: './CertificateList.component.html',
  styleUrls: ['./CertificateList.component.scss']
})
export class CertificateListComponent implements OnInit {
  page:number=0
  Procssing:boolean=false
  DataList_Certificate:Array<Certificate_Interface>=[]
  BaseUrl=environment.BaseUrl

  Customer_Filter_List:string=""

  constructor(
    private Certificate_Service:CertificateService,
    private Nav_Service:NavService,
  ) { }

  ngOnInit() {
    this.Nav_Service.CheckValidPage(13).subscribe(
      data=>{

      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )

  }

  ReadData_Certificate(StartSearchDate,EndSearchDate){
    this.Procssing=true
    this.Certificate_Service.GetBargasb(StartSearchDate,EndSearchDate,this.Customer_Filter_List,"").subscribe(
      data=>{
        this.DataList_Certificate=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  exportexcel(): void
  {
     /* table id is passed over here */
     let element = document.getElementById('excel-table');
     const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

     /* generate workbook and add the worksheet */
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

     /* save to file */
     XLSX.writeFile(wb, "BehfaCertificate.xlsx");

  }

}
